// @flow

import React from 'react';

import {
  withTypedRouter,
  type WithRouterProps,
} from 'app/general/withTypedRouter';
import {SPPage} from 'app/general/structures/SPPage';
import {ErrorContent} from 'app/general/loading/ErrorContent';

type RouterProps = WithRouterProps<>;

const BaseSPErrorPage = () => (
  <SPPage>
    <ErrorContent />
  </SPPage>
);

export const SPErrorPage = withTypedRouter<RouterProps, RouterProps>(
  BaseSPErrorPage
);
